/** Normaliserar radbrytningar från site_content (textarea, Windows-rader, escaped \\n). */
export function normalizeSiteContentLineBreaks(text: string): string {
  if (!text) return '';
  return text
    .replace(/\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');
}

/** Förhandsvisning i admin – behåll radbrytningar men begränsa längd. */
export function previewSiteContentText(text: string, maxLength = 160): string {
  const normalized = normalizeSiteContentLineBreaks(text)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/[ \t]+/g, ' ')
    .trim();

  if (normalized.length <= maxLength) return normalized;
  return `${normalized.slice(0, maxLength).trim()}…`;
}
